module.exports = __webpack_public_path__ + "img/r-cb6-1.31467976.gif";